/**
 * Vision page sections — the company's enduring direction, captured as eight
 * canonical markdown sections (from the EOS system design).
 *
 * Shared owns the STABLE CONTRACT only: section keys, exact markdown headings,
 * and their canonical order. The elicitation copy used to prompt founders lives
 * with the backend prompt assembly (agent/firstRun.ts), since that is its only
 * consumer; the frontend uses these keys/headings for progress display.
 */
export const VISION_SECTIONS = [
    { key: "core-values", heading: "Core Values" },
    { key: "why-we-exist", heading: "Why We Exist" },
    { key: "what-we-do", heading: "What We Do (and don't)" },
    { key: "where-were-going", heading: "Where We're Going" },
    { key: "who-we-serve", heading: "Who We Serve" },
    { key: "how-we-sell", heading: "How We Sell" },
    { key: "three-years", heading: "Where We'll Be in 3 Years" },
    { key: "this-year", heading: "This Year" },
];
const VISION_SECTION_BY_KEY = new Map(VISION_SECTIONS.map((section) => [section.key, section]));
export const VISION_SECTION_KEYS = VISION_SECTIONS.map((section) => section.key);
export function getVisionSection(key) {
    return VISION_SECTION_BY_KEY.get(key);
}
//# sourceMappingURL=vision.js.map